<template>
<div>
	<div class="cover cover--home" :style="'background-image: url(' + require('@/assets/cover-home.jpg') + ')'">
		<div class="wrapper cover__content">
         <h1 class="cover__title">Bring Back<br/>Common Sense</h1>
         <h2 class="cover__subtitle">Join the movement that’s<br>sweeping British Columbia</h2>
         <form class="form form--boxless form--column" method="post" action="https://aarongunn.ca/webservices/forms.php">
            <div style="max-width: 400px; display: flex; flex-wrap: wrap;">
               <div class="form__item form__item--duo form__item--large"><input name="firstname" type="text" placeholder="First Name*" autocomplete="given-name" required/></div>
               <div class="form__item form__item--duo form__item--large"><input name="lastname" type="text" placeholder="Last Name*"  autocomplete="family-name" required/></div>
               <div class="form__item form__item--large"><input name="email" type="email" placeholder="Email Address*" autocomplete="email" required/></div>
               <div class="form__item form__item--duo form__item--large"><input name="zip" type="text" placeholder="B.C. Postal Code*" autocomplete="postal-code" pattern="[vV][0-9][A-Za-z][\s]?[0-9][A-Za-z][0-9]" required/></div>
               <div class="form__item form__item--duo form__item--large"><input name="phone" type="tel" placeholder="Phone Number*" autocomplete="tel" pattern="[1]?[-\s]?[(]?\d{3}[)\s]?[-\s]?\d{3}[-\s]?\d{4}" required/></div>
            </div>
            <input type="hidden" name="source" value="vote"/>
            <input style="margin-top: 20px; max-width: 400px;" type="submit" class="button button--red button--large" value="Join" />
         </form>
		</div>
	</div>

   <div class="wrapper wrapper--spaced">
      <h1 class="title ">A Common Sense Plan<br>for British Columbia</h1>
      <ul class="policies">
         <li class="policies__item">
            <img class="policies__icon" src="@/assets/policies-icons/gasoline-pump.svg" alt=""/>
            <h1 class="policies__title">Scrap the<br>Carbon Tax</h1>
            <h2 class="policies__number">01</h2>
         </li>
         <li class="policies__item">
            <img class="policies__icon" src="@/assets/policies-icons/money-bag.svg" alt=""/>
            <h1 class="policies__title">End the ICBC<br>Monopoly</h1>
            <h2 class="policies__number">02</h2>
         </li>
         <li class="policies__item">
            <img class="policies__icon" src="@/assets/policies-icons/handcuffs.svg" alt=""/>
            <h1 class="policies__title">Crack Down on<br>Crime &amp; Anarchy</h1>
            <h2 class="policies__number">03</h2>
         </li>
         <li class="policies__item">
            <img class="policies__icon" src="@/assets/policies-icons/sprout.svg" alt=""/>
            <h1 class="policies__title">Stand Up<br>for B.C.<br>Resources</h1>
            <h2 class="policies__number">04</h2>
         </li>
         <li class="policies__item">
            <img class="policies__icon" src="@/assets/policies-icons/megaphone.svg" alt=""/>
            <h1 class="policies__title">Defend Free<br>Speech; Oppose<br>Cancel Culture</h1>
            <h2 class="policies__number">05</h2>
         </li>
         <li class="policies__item">
            <img class="policies__icon" src="@/assets/policies-icons/stethoscope.svg" alt=""/>
            <h1 class="policies__title">Fix Our Broken<br>Health Care<br> System</h1>
            <h2 class="policies__number">06</h2>
         </li>
      </ul>
      <div class="wrapper--centered">
         <h1 class="title title--red title--spaced">And, of course, change the Party name!</h1>
         <a class="button button--red button--large" href="/platform" style="display: inline-block;">View Aaron's Complete Platform</a>
      </div>
   </div>

   <div class="blue-box">
      <div class="wrapper wrapper--spaced">
         <h1 class="title title--white title--spaced">Upcoming Events</h1>
         <ul class="events">
            <li class="events__item">
               <div class="events__content">
                  <h1 class="title title--small">Bring Back Common Sense Rally and Special Announcement</h1>
                  <div class="events__location">
                     <img class="events__icon" src="@/assets/map-pin.svg" alt=""/>
                     <div>
                        <p class="events__city">Chilliwack</p>
                        <p class="events__address">Venue: Register for details</p>
                     </div>
                  </div>
               </div>
               <div class="events__content">
                  <p class="events__date">Saturday, November 6th<br>12:45PM</p>
                  <a href="/event" class="button button--red" style="margin-top: 20px">Register</a>
               </div>
            </li>

         </ul>
      </div>
   </div>

   <!-- <div class="grey-box">
      <div class="wrapper wrapper--spaced">
         <h1 class="title title--spaced">Wait, what just happened?</h1>
         <p class="text">Watch the video for a full explanation.</p>
         <br>
         <iframe width="560" height="315" src="https://www.youtube.com/embed/OTNCWaXlRjs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>      </div>
   </div> -->

   <div class="blue-box">
      <div class="wrapper wrapper--spaced">
         <div class="presentation">
            <div>
               <h1 class="title title--white title--spaced">Why I'm Running?</h1>
               <p class="text">British Columbia is my home. This is where I was born, where I grew up and where I live today. </p>
               <p class="text">I’m tired of watching our province head in the wrong direction.</p>
               <p class="text">For too long, politicians have promised us one thing, but failed to deliver once in power. Whether it’s on the cost of living, a broken health care system or a steady deterioration in crime and public safety.</p>
               <p class="text">I believe now, more than ever, is the time for new leadership, new ideas and a bold new vision for our province going forward. I have a plan that puts taxpayers first, respects our constitutional rights and brings common sense policies back to British Columbia.</p>
               <p class="text">To restore our province, I need your support, and humbly ask for your vote.</p>
               <p class="text">Sincerely,</p>
               <img src="@/assets/signature.png" alt=""/>
            </div>
            <img class="presentation__image" src="@/assets/aaron.jpg" alt=""/>
         </div>
      </div>
   </div>

   <div class="wrapper wrapper--spaced white-box">
         <div class="presentation">
            <div>
               <h1 class="title title--spaced">Why the BC Liberals?</h1>
               <p class="text">Since the 1990s, the BC Liberals have been the main anti-NDP coalition party in British Columbia. This has been the case since the collapse of Social Credit. A combination of both federal Liberals and Conservatives make up the vast majority of BC Liberal voters, which is naturally confusing (and paradoxical) for many who are not familiar with B.C. politics.</p>
               <p class="text">As leader of the party, Aaron Gunn will take immediate steps to change the party name and create a principled coalition grounded in common sense policy that can defeat the NDP.</p>
            </div>
            <img class="presentation__image" src="@/assets/bc-liberals-logo.jpg" alt=""/>
         </div>
   </div>

  <div class="blue-box blue-box--light jumbotron" :style="'background-image: url(' + require('@/assets/jumbotron-slogan.jpg') + ')'" style="background-size: cover; height: 600px">

   </div>

   <div class="blue-box blue-box--light jumbotron" :style="'background-image: url(' + require('@/assets/jumbotron-flag.jpg') + ')'">
      <div class="wrapper wrapper--spaced wrapper--centered">
         <h1 class="title title--red title--spaced">Join the movement to Bring Common Sense<br>Back to British Columbia</h1>
         <form  class="form form--boxless form--column" style="display: inline-flex; margin:auto;" method="post" action="https://aarongunn.ca/webservices/forms.php">
            <div style="max-width: 600px; display: flex; flex-wrap: wrap;">
               <div class="form__item form__item--duo form__item--large"><input name="firstname" type="text" placeholder="First Name*" class="cover__input" autocomplete="given-name" required/></div>
               <div class="form__item form__item--duo form__item--large"><input name="lastname" type="text" placeholder="Last Name*" class="cover__input" autocomplete="family-name" required/></div>
               <div class="form__item form__item--large"><input name="email" type="email" placeholder="Email Address*" class="cover__input" autocomplete="email" required/></div>
               <div class="form__item form__item--duo form__item--large"><input name="zip" type="text" placeholder="B.C. Postal Code*" class="cover__input cover__input--small" autocomplete="postal-code" pattern="[vV][0-9][A-Za-z][\s]?[0-9][A-Za-z][0-9]" required/></div>
               <div class="form__item form__item--duo form__item--large"><input name="phone" type="text" placeholder="Phone Number*" class="cover__input" autocomplete="tel" required/></div>
               <div class="form__item"><label class="option"><input type="checkbox" name="volunteer" value="yes"/> I’m interested in learning more about becoming a volunteer</label></div>
               <div class="form__item"><label class="option"><input type="checkbox" name="contribution_interest" value="yes"/> I’m interested in learning more about contributing financially</label></div> 
            </div>
            <input type="hidden" name="source" value="vote"/>
            <input style="max-width: 600px; margin-top: 20px;" type="submit" class="button button--red button--large" value="Join" />
         </form>
      </div>
   </div>

 </div>
</template>

<script>
import facebookMixin from '@/videos-mixin.js'
export default {
	mixins: [facebookMixin],
	created () {

	},
	data() {
		return {

		}
	},
	methods: {

	},
	computed: {

	}
}
</script>

<style scoped>
.policies { margin: 50px 0; display: flex; flex-wrap: wrap; justify-content: space-between; }
.policies__item { width: calc(100% / 3); max-width: 315px; position: relative; display: flex; flex-direction: column; align-items: flex-start; margin: 20px 0 30px; }
.policies__icon { height: 60px; }
.policies__title { border-bottom: 3px solid #E0231C; padding-bottom: 10px; margin: 20px 0; color: #062573; text-transform: uppercase; font-size: 2.5rem; font-weight: bold; }
.policies__number { position: absolute; font-size: 20rem; font-weight: bolder; color: #062573; opacity: 0.05; }

.how {  }
.how__item { display: flex; justify-content: space-around; padding: 20px 0; }
.how__content { width: 60%; flex-basis: 60%; }
.how__step { font-size: 2.5rem; font-weight: 600; text-transform: uppercase; }
.how__drawing { height: auto; width: 225px; max-height: 75px; }

.presentation { display: flex; }
.presentation__text {  }
.presentation__image { width: 30%; }

.events { list-style: none; }
.events__item { display: flex; margin-bottom: 20px; }
.events__content { background: white; color: #7282AA; }
.events__content:first-child { padding: 40px 50px; width: 70%; }
.events__content:last-child { padding: 40px 60px; margin-left: 2px; width: calc(40% - 2px); text-align: center; display: flex; flex-direction: column; justify-content: center; }
.events__location { display: flex; align-items: flex-end; margin-top: 20px; }
.events__icon { width: 40px; }
.events__city { text-transform: uppercase; color: #E0231C; font-weight: bold; font-size: 2rem; }
.events__date { color: #062573; font-size: 2rem; font-weight: 600; }

@media (max-width: 1100px) {

}

@media (max-width: 768px) {
   .policies__item { width: calc(100% / 2) }
   .policies__number { font-size: 15rem; }
   .presentation { flex-direction: column; }
   .presentation__image { width: 100%; margin-top: 50px; }
   .how__item { flex-direction: column-reverse; align-items: center; text-align: center; }
   .how__content { width: 100%; flex-basis: 100%; }
   .how__drawing { margin: 20px 0 30px; }
}

@media (max-width: 526px) {
   .policies { justify-content: center; }
   .policies__item { width: 100%; text-align: center; align-items: center; }
}

</style>
